'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isStringLengthWithinRange = (range, str) => {
    if (range.min > range.max) {
        throw new Error('Invalid range');
    }
    const strLength = (str === null || str === void 0 ? void 0 : str.length) || 0;
    return strLength >= (range.min || 0) && strLength <= range.max;
};

exports.isStringLengthWithinRange = isStringLengthWithinRange;
//# sourceMappingURL=is-string-length-within-range.js.map
